import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Resolve,
  RouterStateSnapshot,
} from '@angular/router';
import { BusinessProfileService } from 'src/app/core/services/onboarding/business-profile.service';

@Injectable({
  providedIn: 'root',
})
export class BusinessInvoiceResolver implements Resolve<any> {
  constructor(private bps: BusinessProfileService) {}
  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<any> {
    return this.bps.loadBusinessInvoice();
  }
}
